/**
 * @enum {number}
 */
var _ol_ImageState_ = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
};

export default _ol_ImageState_;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/imagestate.js
// module id = BV9W
// module chunks = 0